<script setup lang="ts">
const { size = 24, color = '#44445F' } = defineProps<{
  size?: number | string;
  color?: string;
}>();
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="4" :fill="color" />
  </svg>
</template>
